import React from 'react';
import { Table } from 'react-bootstrap';
import Head from "./components/Head";
import Row from "./components/Row";

const BidderFillRateTable = ({ params, paramsObj, report, sources, affids,  onSortChange }) => {
    const rows = report.map((row, index) => (<Row params={params} paramsObj={paramsObj} row={row} sources={sources} affids={affids} key={index} />));
    console.log(sources);
    return (
        <Table bordered responsive>
            <Head onSortChange={onSortChange} params={params} />
            <tbody>
                {rows}
            </tbody>
        </Table>
    )
};

export default BidderFillRateTable;



// WEBPACK FOOTER //
// ./src/scenes/BidderFillRate/components/Table/index.js